import { useEffect, useState } from "react";

// Reads localStorage["language"] (default "da") and stays in sync with the
// account-menu language toggle via the "app-language-changed" window event.
export default function useLanguage() {
  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "da",
  );

  useEffect(() => {
    const handler = (event) => {
      setLanguage(event.detail || "da");
    };
    window.addEventListener("app-language-changed", handler);
    return () => window.removeEventListener("app-language-changed", handler);
  }, []);

  const setAndPersistLanguage = (next) => {
    setLanguage(next);
    localStorage.setItem("language", next);
    window.dispatchEvent(
      new CustomEvent("app-language-changed", { detail: next }),
    );
  };

  return [language, setAndPersistLanguage];
}
